import React from "react";

const Cart = () => {
  return (
    <div className="container">
      <h1>Cart Page</h1>
    </div>
  );
};

export default Cart;
